import TextareaAutosize from 'react-textarea-autosize';
import TextButton from '../TextButton';
import InlineSVG from 'react-inlinesvg';
import React, { useCallback } from 'react';
import { useAppStore } from '../../stores/appStore';
import StyledSelect from '../StyledSelect';

export default function AddCharacterGuidance({
  containerRef,
  value,
  onChange,
  onKeyDown,
  onRandomGenerateClick,
  disabled,
  onGenerateSubmitted,
  className,
  roleOptions = [],
  selectedRole,
  onSelectRole = () => {},
  roleSelectId = 'generate-character-role',
}) {
  const handleTextAreaChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );
  const handleRoleChange = useCallback(
    (option) => {
      onSelectRole(option?.value || null);
    },
    [onSelectRole]
  );

  const selectedRoleOption = roleOptions.find((option) => option.value === selectedRole) || roleOptions[0] || null;

  const isMac = useAppStore((state) => state.isMac);

  return (
    <div
      ref={containerRef}
      className={"guidance" + (className ? ` ${className}` : "")}
    >
      {roleOptions.length > 0 && (
        <div className="role-select">
          <label htmlFor={roleSelectId}>Character Type</label>
          <StyledSelect
            inputId={roleSelectId}
            className="role-selector"
            value={selectedRoleOption}
            options={roleOptions}
            onChange={handleRoleChange}
            placeholder="Select type"
            aria-label="Select the character role template"
          />
        </div>
      )}
      <TextareaAutosize
        value={value}
        placeholder='Write custom instructions...&#10;e.g. "A best friend for my protagonist"'
        onChange={handleTextAreaChange}
        autoFocus={true}
        onKeyDown={onKeyDown}
      />
      <div className="guidanceButtons">
        <TextButton
          className="randomCharacterButton"
          onClick={onRandomGenerateClick}
          disabled={disabled}
          ariaLabel="Generate a random character"
        >
          <InlineSVG
            src="/assets/dice.svg"
            aria-hidden="true"
          />
          Random Character
        </TextButton>
        <button
          className="goButton"
          onClick={onGenerateSubmitted}
          disabled={disabled}
          aria-label="Go"
        >
          Go
          <div
            className="keyboard-shortcut-container"
            aria-label={`Press ${isMac ? "command" : "control"} plus enter to generate a character with guidance`}
            role="button"
          >
            <InlineSVG
              src={isMac ? "/assets/keyboard-shortcuts/command-key.svg" : "/assets/keyboard-shortcuts/control-key-pc.svg"}
              className="keyboard-shortcut"
              aria-hidden="true"
            />
            <InlineSVG
              src="/assets/keyboard-shortcuts/enter-key.svg"
              className="keyboard-shortcut"
              aria-hidden="true"
            />
          </div>
        </button>
      </div>
    </div>
  );
}
